import React from "react";
import BrowserBezel from "components/BrowserBezel";
import CheckoutPreviewLoader from "components/CheckoutPreview/Loader";

const ShortLinkPreviewLoader = () => (
  <BrowserBezel>
    <div className="flex flex-column flex-row-l">
      <div className="w-100 w-50-l pa3 pa4-l bn br-l hairline-1">
        <CheckoutPreviewLoader withShimmer />
      </div>
      <div className="w-100 w-50-l pa3 pa4-l h-100">
        <div className="flex shimmer h2 w-20"></div>
        <div className="pt2 w-100">
          <div className="shimmer h2 w-50"></div>
        </div>
        <div className="pt2 w-100">
          <div className="shimmer h2 w-100"></div>
        </div>
        <div className="pt2 w-100">
          <div className="shimmer h2 w-100"></div>
        </div>
        <div className="pt2 w-100">
          <div className="shimmer h2 w-100"></div>
        </div>
        <div className="pt2 w-100">
          <div className="shimmer h2 w-100"></div>
        </div>
        <div className="pt2 w-100">
          <div className="shimmer h2 w-100"></div>
        </div>
        <div className="pt2 w-100">
          <div className="shimmer h3 w-50 center"></div>
        </div>
      </div>
    </div>
  </BrowserBezel>
);

export default ShortLinkPreviewLoader;
